import { ENV } from "#shared/env";

export const getOrgDomain = (domain?: string) =>
  domain ? `${domain}.${ENV.VITE_APP_DOMAIN}` : ENV.VITE_APP_DOMAIN;
